const reloadRoute = () => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};

export default reloadRoute;
